// export const baseUrl = 'https://jsj.ycqingzhi.com/api/v1';  // 本地
// export const Url = 'https://jsj.ycqingzhi.com';
// export const baseUrl = 'http://jiusj.test.zqwhcb.com/api/v1';  // 测试
// export const Url = 'http://jiusj.test.zqwhcb.com';
export const baseUrl = 'https://qichunjiushijia.com/api/v1';  // 生产
export const Url = 'https://qichunjiushijia.com';
// export const baseUrl = 'https://hubeiaiyoutang.com/api/v1';  // 生产
// export const Url = 'https://hubeiaiyoutang.com';
// export const baseUrl = 'http://dev.hubeiaiyoutang.com/api/v1';  // 生产
//  export const Url = 'http://dev.hubeiaiyoutang.com';
export const imgBaseUrl = 'http://qn.fayuanhui.cn/default.png';
export const version = '1.0.51';

export default {
  baseUrl, imgBaseUrl, version,Url
}



// WEBPACK FOOTER //
// ./src/config/CONSTANTS.js